import { format, parseISO } from "date-fns";

export const transformDate = (dateString: string): string => {
	if (!dateString) return "";
	return format(parseISO(dateString), "LLLL d, yyyy");
};
